import { Injectable, NgZone } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { NavController } from '@ionic/angular';
import { CoreButtonStyle } from '../../core-modules/components/core-button/core-button.component';
import { MessagePageOptions } from '../pages/message/message.page.data';
import { MessageIcon } from '../pages/message/message.page.icons';

/*
 * Generated class for the ErrorHandlerProvider provider.
 */
@Injectable()
export class MessagePageController
{

    //#region Constructors

    /**
     * Class constructor
     */
    constructor
        (
            private navCtrl: NavController,
            private ngZone: NgZone,
        )
    {
    }

    //#endregion


    //#region Methods

    /**
     * Go to the message page
     * @param params  {MessagePageOptions} message page options
     * @param setRoot {boolean} replace the root page
     */
    public goToMessagePage(params: MessagePageOptions, setRoot: boolean = true): Promise<boolean>
    {
        return this.ngZone.run(() =>
        { 
            // if no buttons have been specified then show the continue button by default
            if (!params.buttons)
            {
                params.buttons = [
                    {
                        text: 'Continue',
                        style: CoreButtonStyle.Solid,
                        action: () =>
                        {
                            this.continueButtonHandler();
                        }
                    }
                ];
            }

            let navigationExtras: NavigationExtras = {
                queryParams: {
                    options: params
                }
            };
            if (setRoot)
            {
                // go to the message page
                return this.navCtrl.navigateRoot('/message', navigationExtras);
            } else
            {
                return this.navCtrl.navigateForward('/message', navigationExtras);
            }
        });
    }

    /**
     * Go to the not found page
     */
    public goToNotFoundPage(): Promise<boolean>
    {
        return this.goToMessagePage
            ({
                icon: MessageIcon.GENERIC,
                messageExclaimation: `Oops!`,
                messageTagline: `We could not find that page!`,
                messageDescription: `Sorry, we could not find what you're looking for!`,
            });
    }

    /**
    * This is the method used to handle go back home button
    * events created in the message page
    */
    private async continueButtonHandler()
    {
        await this.navCtrl.navigateRoot('/landing');
    }

    //#endregion
}
